import {
  groupInput,
  input,
  InputProvider,
  nonEmptyValidator,
} from "@redotech/ui/form";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const StallionExpressCarrierInput = groupInput({
  apiToken: input<string>({ validator: nonEmptyValidator }),
});

export type StallionExpressCarrierValue = InputProvider.Value<
  typeof StallionExpressCarrierInput
>;

export type StallionExpressCarrierForm = InputProvider.Form<
  typeof StallionExpressCarrierInput
>;

export const StallionExpressCarrierDefault =
  (): StallionExpressCarrierValue => ({ apiToken: "" });

export const CreateStallionExpressCarrierForm = memo(
  function CreateStallionExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: StallionExpressCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="API token"
        placeholder=""
        setValue={carrierInput.inputs.apiToken.setValue}
        value={carrierInput.inputs.apiToken.value}
      />
    );
  },
);
